import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { clamp } from '@/shared/lib/math/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'CCircularTimer',
  props: {
    color: {
      default: undefined
    },
    gradient: {
      default: undefined
    },
    backgroundColor: {
      default: '#f8ebf8'
    },
    size: {
      default: 100
    },
    lineWidth: {
      default: 4
    },
    expirationDate: {
      default: undefined
    }
  },
  emits: ["time-expired"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var gradientId = ref();
    var intervalId = ref();
    var initialTimeRemaining = ref();
    var timeRemaining = ref();
    var timer = computed(function () {
      var _timeRemaining$value;
      var seconds = (_timeRemaining$value = timeRemaining.value) !== null && _timeRemaining$value !== void 0 ? _timeRemaining$value : 0;
      var h = Math.floor(seconds / 3600);
      var m = Math.floor(seconds % 3600 / 60);
      return {
        hours: String(h).padStart(2, '0'),
        minutes: String(m).padStart(2, '0')
      };
    });
    var halfSize = computed(function () {
      return Number(props.size) / 2;
    });
    var calculatedLineWidth = computed(function () {
      return Number(props.lineWidth) > halfSize.value ? halfSize.value : props.lineWidth;
    });
    var radius = computed(function () {
      return halfSize.value - Number(calculatedLineWidth.value) / 2;
    });
    var circumference = computed(function () {
      return 2 * Math.PI * radius.value;
    });
    var strokeDashArray = computed(function () {
      return Math.round(circumference.value * 1000) / 1000;
    });
    var progressValue = computed(function () {
      if (timeRemaining.value && initialTimeRemaining.value) {
        return Math.round(timeRemaining.value * 100 / initialTimeRemaining.value);
      }
      return 0;
    });
    var normalizedValue = computed(function () {
      return clamp(progressValue.value, 0, 100);
    });
    var strokeDashOffset = computed(function () {
      return (100 - normalizedValue.value) / 100 * circumference.value;
    });
    var viewBoxAttribute = computed(function () {
      return "0 0 ".concat(props.size, " ").concat(props.size);
    });
    var strokeWidth = computed(function () {
      return Number(calculatedLineWidth.value);
    });
    var wrapperStyles = computed(function () {
      return {
        '--size': "".concat(Number(props.size), "px")
      };
    });
    var firstCircleAttributes = computed(function () {
      return {
        'fill': 'transparent',
        'cx': halfSize.value,
        'cy': halfSize.value,
        'r': radius.value,
        'stroke-width': strokeWidth.value,
        'stroke-dasharray': strokeDashArray.value,
        'stroke-dashoffset': 0
      };
    });
    var firstCircleColor = computed(function () {
      return props.backgroundColor || 'transparent';
    });
    var secondCircleAttributes = computed(function () {
      return _objectSpread(_objectSpread({}, firstCircleAttributes.value), {}, {
        'stroke-dashoffset': strokeDashOffset.value
      });
    });
    var secondCircleColor = computed(function () {
      if (props.color) {
        return props.color;
      }
      if (props.gradient) {
        return "url(#".concat(gradientId.value, ")");
      }
      return 'transparent';
    });
    function calculateTimeRemaining() {
      var remaining = Math.floor((new Date(props.expirationDate).getTime() - Date.now()) / 1000);
      return remaining > 0 ? remaining : 0;
    }
    function start() {
      clearInterval(intervalId.value);
      timeRemaining.value = calculateTimeRemaining();
      intervalId.value = setInterval(function () {
        timeRemaining.value = calculateTimeRemaining();
      }, 1000);
    }
    function handleVisibilityChange() {
      if (document.hidden) {
        clearInterval(intervalId.value);
      } else {
        start();
      }
    }
    watch(timeRemaining, function (value) {
      if (value !== undefined && value <= 0) {
        clearInterval(intervalId.value);
        emit('time-expired');
      }
    });
    onMounted(function () {
      gradientId.value = "gradient-".concat(Date.now(), "-").concat(Math.floor(Math.random() * 100000));
      initialTimeRemaining.value = calculateTimeRemaining();
      start();
      document.addEventListener('visibilitychange', handleVisibilityChange);
    });
    onBeforeUnmount(function () {
      clearInterval(intervalId.value);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      gradientId: gradientId,
      intervalId: intervalId,
      initialTimeRemaining: initialTimeRemaining,
      timeRemaining: timeRemaining,
      timer: timer,
      halfSize: halfSize,
      calculatedLineWidth: calculatedLineWidth,
      radius: radius,
      circumference: circumference,
      strokeDashArray: strokeDashArray,
      progressValue: progressValue,
      normalizedValue: normalizedValue,
      strokeDashOffset: strokeDashOffset,
      viewBoxAttribute: viewBoxAttribute,
      strokeWidth: strokeWidth,
      wrapperStyles: wrapperStyles,
      firstCircleAttributes: firstCircleAttributes,
      firstCircleColor: firstCircleColor,
      secondCircleAttributes: secondCircleAttributes,
      secondCircleColor: secondCircleColor,
      calculateTimeRemaining: calculateTimeRemaining,
      start: start,
      handleVisibilityChange: handleVisibilityChange
    };
  }
});